export default "__VITE_ASSET__wyx5P1GN__"